import { DemoContainer } from '@mui/x-date-pickers/internals/demo'
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { IconButton, Menu, MenuItem } from "@mui/material";
import Box from '@mui/material/Box'
import NoDataImg from '../../../assets/img/no-data.gif'
import Switch from '@mui/material/Switch'
import Dropdown from 'react-bootstrap/Dropdown'
import Button from '@mui/material/Button'
import AddIcon from '@mui/icons-material/Add'
import Form from 'react-bootstrap/Form'
import Pagination from '@mui/material/Pagination'
import SearchIcon from '@mui/icons-material/Search'
import InputGroup from 'react-bootstrap/InputGroup'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { v4 as uuidv4 } from 'uuid';
import { Fragment, useCallback, useEffect, useState } from 'react';
import InsufficientPermission from '../../custom/InSufficientPermission';
import NavBar from '../../structure/NavBar';
import { NavBarTop } from '../../structure/NavBarTop';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { updateTopHeader, updateLoading } from '../../../redux/features/common/commonSlice';
import Utils from '../../constants/Utils';
import urls from '../../constants/apiurl';
import ApiCaller from '../../constants/ApiCaller';
import { showDangerToast, showToast } from '../../constants/toaster';
const label = { inputProps: { 'aria-label': 'Size switch demo' } }
export const BotAccountUserList = () => {
    const [selectedUser, setSelectedUser] = useState({})
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const [datalist, setDatalist] = useState([]);
    const userData = useSelector(state => state?.userData)
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const LOADING_ENABLE = useSelector(state => state?.loading)
    const [sort_type, setSortType] = useState('createdAt')
    const [searchText, setSearchText] = useState("")
    const [statusDropdownText, setStatusDropdownText] = useState('Select Status')
    const [activeInActiveStatus, setActiveInActiveStatus] = useState(null)
    const [startDate, setStartDate] = useState(null)
    const [endDate, setEndDate] = useState(null)
    const [sort_order, setSortOrder] = useState(false)
    const { formatDate } = Utils();
    const [callAPi, setCallAPi] = useState('')
    const [page, setPage] = useState(1)
    const [pagerecord, setPagerecord] = useState({
        totalItems: 0,
        pageNumber: 1,
        pageSize: 10,
        totalPages: 1
    })

    const userPermisiions = useSelector(state => state?.permission)
    let currentModulePermission;
    let viewPermission = true;
    let editPermission = true;
    let deletePermissionVal = true;
    let activePermission = true;

    if (userPermisiions?.modules.length > 0) {
        currentModulePermission = userPermisiions.modules.find((element) => {
            if (element.moduleId === '4') {
                return element
            }
        })?.permissions
        viewPermission = currentModulePermission.find((element) => {
            if (element.name === 'VIEW') {
                return element
            }
        }).isEnable
        editPermission = currentModulePermission.find((element) => {
            if (element.name === 'EDIT') {
                return element
            }
        }).isEnable
        deletePermissionVal = currentModulePermission.find((element) => {
            if (element.name === 'DELETE') {
                return element
            }
        }).isEnable
        activePermission = currentModulePermission.find((element) => {
            if (element.name === 'ACTIVE') {
                return element
            }
        }).isEnable
    }

    const [edit, setEdit] = useState(false)
    const [active, setActive] = useState(false)
    const [deletePermission, setDeletePermission] = useState(false)
    const [view, setView] = useState(false)

    const handleClick = (event, item) => {
        setAnchorEl(event.currentTarget);
        setSelectedUser(item)
    };

    const handleClose = () => {
        setAnchorEl(null);
    };
    useEffect(() => {
        dispatch(updateTopHeader('Bot Account Manager'))
    })

    useEffect(() => {
        getUserList()
    }, [callAPi])

    const handleChange = (event, value) => {
        setPage(value)
        setPagerecord({
            totalItems: pagerecord?.totalItems,
            totalPages: pagerecord?.totalPages,
            pageNumber: value,
            pageSize: 10
        })
        setCallAPi(uuidv4())
    }


    const handleStatusChange = async (event, id) => {
        try {
            dispatch(updateLoading(true))
            let path = urls.activeInActiveVideo + '?videoId=' + id
            let res = await ApiCaller.get({}, path, userData?.access_token)
            const response = await res.response.json()
            if (response.status == 200) {
                dispatch(updateLoading(false))
                showToast(response?.message)
            } else {
                dispatch(updateLoading(false))
                showDangerToast(response.message)
            }
        } catch (error) {
            dispatch(updateLoading(false))
            console.error(error)
            showDangerToast(error.message)
        }
    }

    const handleViewUser = async () => {
        handleClose()
        console.log(selectedUser)
        navigate(`/user-manager/${selectedUser?.id}`)
    }



    const handleResetFilter = () => {
        setSearchText('')
        setStartDate(null)
        setEndDate(null)
        setStatusDropdownText("Select Status")
        setActiveInActiveStatus(null)
        setPage(1);
        setPagerecord({
            ...pagerecord,
            pageNumber: 1
        })
        setCallAPi(uuidv4())
    }

    // Handle filter click
    const handleFilterClick = useCallback(() => {
        setPage(1);
        setPagerecord({
            ...pagerecord,
            pageNumber: 1
        })
        setCallAPi(uuidv4())
    }, [searchText, activeInActiveStatus, startDate, endDate]);


    const getUserList = async () => {
        try {
            dispatch(updateLoading(true))
            let startDateObject;
            let endDateObject;
            if (startDate?.toDate()) {
                // Create a new Date object based on startDate
                let newDate = new Date(startDate?.toDate());

                // Add one day
                newDate.setDate(newDate.getDate() + 1);
                startDateObject = newDate;
            }
            if (endDate?.toDate()) {
                // Create a new Date object based on startDate
                let newDate = new Date(endDate?.toDate());

                // Add one day
                newDate.setDate(newDate.getDate() + 1);
                endDateObject = newDate;
            }


            let postJson = {
                searchText: searchText?.trim(),
                active:
                    statusDropdownText === 'Active'
                        ? true
                        : statusDropdownText === 'In Active'
                            ? false
                            : '',
                kycStatus: "ALL",
                pageNumber: pagerecord?.pageNumber - 1 || 0,
                pageSize: pagerecord.pageSize || 10,
                shortingField: sort_type,
                asc: sort_order,
                paid: false,
                startDate:
                    startDateObject !== null
                        ? startDateObject
                        : '',
                endDate:
                    endDateObject !== null
                        ? endDateObject
                        : '',
            }
            let path = urls.botAccountList
            let res = await ApiCaller.post(postJson, path, userData?.access_token)
            const response = await res.response.json()
            if (response.status == 200) {
                dispatch(updateLoading(false))
                setDatalist(response?.data?.response?.items)
                response?.data?.permissionList.forEach((module, moduleIndex) => {
                    if (module.permissionName === 'EDIT') {
                        setEdit(module.isEnable)
                    } else if (module.permissionName === 'ACTIVE') {
                        setActive(module.isEnable)
                    } else if (module.permissionName === 'DELETE') {
                        setDeletePermission(module.isEnable)
                    } else if (module.permissionName === 'VIEW') {
                        setView(module.isEnable)
                    }
                })
                setPagerecord({
                    totalItems: response?.data?.response?.totalItems,
                    totalPages: response?.data?.response?.totalPages,
                    pageNumber: pagerecord?.pageNumber,
                    pageSize: 10
                })


            } else {
                dispatch(updateLoading(false))
                showDangerToast(response.message)
            }
        } catch (error) {
            dispatch(updateLoading(false))
            console.error(error)
            showDangerToast(error.message)
        }
    }

    return <>
        <NavBar />
        <div className='main-content'>
            <NavBarTop />
            <div className='header'>
                <div className='logo'>
                    <div className='header bg-gradient-primary pb-8 pt-5 pt-md-8'></div>
                </div>
            </div>
            {
                viewPermission ? (
                    <>
                        <div className='container-fluid mt--7'>
                            <div className='row'>
                                <div className='col text-left'>
                                    <div className='card shadow'>
                                        <div className='card-header border-0'>
                                            <div className='row align-items-center text-left'>
                                                <div className='col'>
                                                    <h3 className='mb-0'>Bot Accounts List</h3>
                                                </div>
                                                <div className='col text-right'>
                                                    <Link
                                                        to={'/bot-manager/generate'}
                                                        className='btn btn-sm btn-primary text-white'
                                                    >
                                                        <AddIcon />
                                                        Generate Bot Account
                                                    </Link>

                                                    {/* <a href='#!' className='btn btn-sm btn-primary'>
                        See all
                      </a> */}
                                                </div>
                                            </div>
                                        </div>
                                        <div className='card-header border-0'>
                                            <div className='row align-items-center text-left'>
                                                <div className='col-md-3'>
                                                    <InputGroup
                                                        className='mb-2'
                                                        style={{ borderRadius: '10px' }}
                                                    >
                                                        <Form.Control
                                                            value={searchText}
                                                            onChange={(e) => setSearchText(e.target.value)}
                                                            placeholder='Search by User Name or ID'
                                                            aria-label='Amount (to the nearest dollar)'
                                                        />
                                                    </InputGroup>
                                                </div>
                                                <div className='col-md-2 mb-2 '>
                                                    <Dropdown>
                                                        <Dropdown.Toggle
                                                            variant='success'
                                                            style={{
                                                                backgroundColor: 'white',
                                                                color: 'black',
                                                                border: '1px solid #cad1d7',
                                                                boxShadow: 'none',
                                                                transform: 'none'
                                                            }}
                                                            id='dropdown-basic'
                                                        >
                                                            {statusDropdownText}
                                                        </Dropdown.Toggle>
                                                        <Dropdown.Menu>
                                                            <Dropdown.Item
                                                                onClick={() => {
                                                                    setStatusDropdownText('Select Status')
                                                                    setActiveInActiveStatus(null)
                                                                }
                                                                }
                                                            >
                                                                Select Status
                                                            </Dropdown.Item>
                                                            <Dropdown.Item
                                                                onClick={() => {
                                                                    setStatusDropdownText('Active')
                                                                    setActiveInActiveStatus(true)
                                                                }}
                                                            >
                                                                Active
                                                            </Dropdown.Item>
                                                            <Dropdown.Item
                                                                onClick={() => {
                                                                    setStatusDropdownText('In Active')
                                                                    setActiveInActiveStatus(false)
                                                                }}
                                                            >
                                                                In Active
                                                            </Dropdown.Item>
                                                        </Dropdown.Menu>
                                                    </Dropdown>
                                                </div>
                                                <div
                                                    className='col-md-6 mb-3'
                                                    style={{ marginLeft: '20px' }}
                                                >
                                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                        <DemoContainer
                                                            components={['DatePicker', 'DatePicker']}
                                                        >
                                                            <DatePicker
                                                                disableFuture
                                                                className='custom-date'
                                                                label='From Date'
                                                                value={startDate}
                                                                onChange={newValue => setStartDate(newValue)}
                                                                maxDate={endDate}
                                                            />
                                                            <DatePicker
                                                                disableFuture
                                                                label='To Date'
                                                                value={endDate}
                                                                minDate={startDate}
                                                                onChange={newValue => setEndDate(newValue)}
                                                            />
                                                        </DemoContainer>
                                                    </LocalizationProvider>
                                                </div>
                                                <div className='col-md-3 mb-2'>
                                                    <Button
                                                        variant='contained'
                                                        className='custom-filter-btn'
                                                        onClick={handleFilterClick}
                                                    >
                                                        Filter
                                                    </Button>
                                                    <Button
                                                        variant='contained'
                                                        className='ml-2 custom-filter-btn'
                                                        onClick={handleResetFilter}
                                                    >
                                                        Reset
                                                    </Button>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='table-responsive'>
                                            {datalist?.length ? (
                                                <>
                                                    <table className='table align-items-center table-flush'>
                                                        <thead className='thead-light'>
                                                            <tr>
                                                                <th scope='col'>User ID</th>
                                                                <th scope='col'>User Name</th>
                                                                <th scope='col'>Mobile No.</th>
                                                                <th scope='col'>Registered Date</th>
                                                                <th scope='col'>Total Chips</th>
                                                                <th scope='col'>Total Followers</th>
                                                                <th scope='col'>Total Likes</th>
                                                                <th scope='col'>Total Videos</th>
                                                                <th scope='col'>Total Subscribers</th>
                                                                <th scope='col'>Status</th>
                                                                <th scope='col'>Badge</th>
                                                                <th scope='col'>Actions</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {datalist?.map((data, i) => {
                                                                return (
                                                                    <Fragment key={i}>
                                                                        <tr>
                                                                            <td>{data?.userId ? data?.userId.toString().padStart(8, '0') : ''}</td>
                                                                            <td>{data?.userName}</td>
                                                                            <td>{data?.contactNumber}</td>
                                                                            <td>{formatDate(data?.createdAt)}</td>
                                                                            <td>{data?.balance?.toFixed(2)}</td>
                                                                            <td>{data?.followers}</td>
                                                                            <td>{data?.likes}</td>
                                                                            <td>{data?.videos}</td>
                                                                            <td>{data?.subscribers}</td>
                                                                            <td>
                                                                                {userData.admin ? (
                                                                                    <Switch
                                                                                        {...label}
                                                                                        checked={data?.active}
                                                                                        onChange={(e) => {
                                                                                            handleStatusChange(e, data?.id)
                                                                                        }
                                                                                        }
                                                                                        size='small'
                                                                                    />
                                                                                ) : viewPermission ? (
                                                                                    <Switch
                                                                                        {...label}
                                                                                        disabled={!activePermission}
                                                                                        checked={data?.active}
                                                                                        onChange={(e) => {
                                                                                            if (activePermission) {
                                                                                                handleStatusChange(e, data?.id)
                                                                                            }
                                                                                        }
                                                                                        }
                                                                                        size='small'
                                                                                    />
                                                                                ) : (
                                                                                    <></>
                                                                                )}
                                                                            </td>
                                                                            <td>
                                                                                <Switch
                                                                                    {...label}
                                                                                    checked={data?.badged}
                                                                                    disabled={!editPermission}
                                                                                    onChange={e => {
                                                                                        if (editPermission) {
                                                                                            alert(data)
                                                                                        }
                                                                                    }}
                                                                                    size='small'
                                                                                />
                                                                            </td>
                                                                            <td className='text-right'>
                                                                                <IconButton size="small" onClick={(e) => handleClick(e, data)}>
                                                                                    <MoreVertIcon />
                                                                                </IconButton>
                                                                                <Menu
                                                                                    anchorEl={anchorEl}
                                                                                    open={open}
                                                                                    onClose={handleClose}
                                                                                    anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                                                                                    transformOrigin={{ vertical: "top", horizontal: "right" }}
                                                                                >
                                                                                    {(userData.admin || editPermission) && (
                                                                                        <MenuItem
                                                                                            onClick={() => {
                                                                                                handleClose()
                                                                                                // setShowEditBead(true)
                                                                                                // setUserBalance(selectedUser?.balance)
                                                                                                // setUserId(selectedUser?.userId)
                                                                                            }}
                                                                                        >
                                                                                            Edit
                                                                                        </MenuItem>
                                                                                    )}
                                                                                    <MenuItem
                                                                                        onClick={() => handleViewUser(selectedUser)}
                                                                                    >
                                                                                        View
                                                                                    </MenuItem>
                                                                                </Menu>
                                                                            </td>
                                                                        </tr>
                                                                    </Fragment>
                                                                )
                                                            })}
                                                        </tbody>
                                                    </table>
                                                </>
                                            ) : (
                                                <>
                                                    <div className='text-center'>
                                                        <img width={'25%'} src={NoDataImg}></img>
                                                        <br />
                                                        <label style={{ fontWeight: 'bold' }}>
                                                            {LOADING_ENABLE ? <>Loading Data.....</> : <>No Data Found</>}
                                                        </label>
                                                    </div>
                                                </>
                                            )}
                                        </div>
                                        {datalist && datalist.length > 0 ? (
                                            <div className='card-footer py-4'>
                                                <Box display='flex' justifyContent='right' alignItems='center'>
                                                    <span>Total record: {pagerecord?.totalItems}</span>
                                                    <Pagination
                                                        className='custom-pagination-class'
                                                        count={pagerecord?.totalPages}
                                                        page={page}
                                                        onChange={handleChange}
                                                        color='secondary'
                                                    />
                                                </Box>
                                            </div>
                                        ) : (
                                            <></>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                ) : (<InsufficientPermission />)
            }
        </div>

    </>
}